import Vue, { CreateElement } from 'vue'
import { Subtitle1 } from '@src/elements/typography/typography'
import type { WorkoutLiveData } from '@src/state/store'
import { Prop } from 'vue-property-decorator'
import { WorkoutExercise } from '@src/data/workout-exercise'
import Component from 'vue-class-component'

import './live-workout.sass'
import {
  MobileLandscapeNotSupportedOverlay
} from '@src/components/mobile-landscape-not-supported-overlay/MobileLandscapeNotSupportedOverlay'

@Component
export class WorkoutSummary extends Vue {

  @Prop({ required: true })
  workoutLiveData: WorkoutLiveData

  @Prop({ required: true })
  videoAutoplay: boolean

  @Prop({ required: true })
  currentExercise: WorkoutExercise

  @Prop({ required: true })
  svgCircleSettings: any

  @Prop({ required: true })
  timerString: string

  @Prop({ required: true })
  closePage: () => void

  @Prop({ required: true })
  videoUrl: string

  render (h: CreateElement) {
    const exerciseName = this.$te(`EXERCISE[${this.currentExercise.exercise.number}].NAME`) ?
      this.$t(`EXERCISE[${this.currentExercise.exercise.number}].NAME`) : this.currentExercise.exercise.name

    return (
      <div class='live-workout-wrapper'>
        <MobileLandscapeNotSupportedOverlay />
        <div class='video-wrapper'>
          <div class='preview-overlay'>
            <Subtitle1>{this.$t('PAGE.MEMBERS.TRAINING.HISTORY.WELL_DONE')}</Subtitle1>
          </div>
          <video
            class={`${this.currentExercise.side !== 'right' ? '' : 'mirrored'}`}
            id='exercise-video-summary'
            ref={'exercise-video'}
            src={this.videoUrl}
            playsInline
          />
        </div>
        <div class='live-data-wrapper'>
          <div class='live-data'>
            <div class='exercise-name'>
              <Subtitle1>{exerciseName}</Subtitle1>
            </div>
            <div class='workout-data'>
              <div class='results-wrapper'>
                <div class='check-wrapper' style={{
                  width: this.svgCircleSettings.outerRadius + 'px',
                  height: this.svgCircleSettings.outerRadius + 'px'
                }}>
                  <div class='check'/>
                </div>
                <div
                  class='timer'>
                  {this.timerString}
                </div>
                <div class='state-workout-button' onClick={this.closePage}>
                  {this.$t('DONE')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
